import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Reveal } from './motion/Reveal';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const formatAnswer = (text) => {
    return String(text || '').split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  const faqData = t('faq.questions', { returnObjects: true });
  const questions = Array.isArray(faqData) ? faqData : [];

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="faq-layout">
          <Reveal className="faq-intro">
            <h2 className="section-title">{t('faq.title')}</h2>
            <p className="section-subtitle">{t('faq.description')}</p>
            <a href="#contact-us" className="btn btn-primary faq-contact-cta">
              {t('contact_form.title')}
            </a>
          </Reveal>
          <div className="faq-container">
            {questions.map((item, index) => {
              const isOpen = activeIndex === index;
              const panelId = `faq-panel-${index}`;
              const buttonId = `faq-button-${index}`;
              return (
                <div
                  key={index}
                  className={`faq-item ${isOpen ? 'active' : ''}`}
                >
                  <h3 className="faq-heading">
                    <button
                      type="button"
                      id={buttonId}
                      className="faq-question"
                      aria-expanded={isOpen}
                      aria-controls={panelId}
                      onClick={() => toggleAccordion(index)}
                    >
                      <span>{item.question}</span>
                      <motion.span
                        className="icon"
                        aria-hidden="true"
                        animate={{ rotate: isOpen ? 180 : 0 }}
                        transition={{ duration: reduce ? 0 : 0.28 }}
                      >
                        <FaChevronDown />
                      </motion.span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        id={panelId}
                        role="region"
                        aria-labelledby={buttonId}
                        className="faq-answer active"
                        initial={reduce ? false : { height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={reduce ? { opacity: 1 } : { height: 0, opacity: 0 }}
                        transition={{ duration: reduce ? 0 : 0.32, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <div className="faq-answer-inner">
                          {formatAnswer(item.answer)}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
